import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./tailwind.css";
import "./styles/liquid-glass.css";
import "./styles/bet-placed-row.css";
import "./styles/brawler-brand.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { UserProvider } from "./components/login/UserContext";
import ErrorBoundary from "./components/commons/ErrorBoundary";
import { initPostHog } from "./analytics/posthog";
import { initGa4 } from "./analytics/ga4";
import { initClarity } from "./analytics/clarity";
import { initAttribution } from "./analytics/attribution";
import { analyticsOptedOut } from "./analytics/privacy-signals";

// A Global Privacy Control signal opts the visitor out of analytics, so the
// vendor scripts are never loaded (see analytics/privacy-signals.ts).
if (!analyticsOptedOut()) {
  initPostHog();
  initGa4();
  initClarity();
  // Runs before the router so campaign params are read from the landing URL.
  initAttribution();
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <div className="mainBackground">
        <UserProvider>
          <App />
        </UserProvider>
      </div>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
